import { StyledForecastLoader } from './ForecastLoader.style';
import ForecastLoadingImg from './forecast-loading.svg';

const ForecastLoader = () => {
  return (
    <StyledForecastLoader>
      <header>Analyzing historical data...</header>
      <main>
        <img src={ForecastLoadingImg} />
      </main>
    </StyledForecastLoader>
  );
};

export default ForecastLoader;
